import React from 'react';

export default function LoadingSpinner({ size = 'md', className = '', showMascot = false, message = '' }) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const mascotSizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-20 h-20'
  };

  if (showMascot) {
    return (
      <div className={`flex flex-col justify-center items-center ${className}`}>
        <div className="relative mb-4">
          <img 
            src="/TGChibi.png" 
            alt="TypoGuard Mascot" 
            className={`${mascotSizeClasses[size]} object-contain animate-pulse`}
          />
          <div className={`absolute -bottom-2 -right-2 ${sizeClasses[size]} border-2 border-gray-300 border-t-mint-600 rounded-full animate-spin`}></div>
        </div>
        {message && (
          <p className="text-sm text-gray-600 dark:text-gray-400 text-center max-w-xs">
            {message}
          </p>
        )}
      </div>
    );
  }

  return (
    <div className={`flex justify-center items-center ${className}`}>
      <div className={`${sizeClasses[size]} border-2 border-gray-300 border-t-mint-600 rounded-full animate-spin`}></div>
    </div>
  );
}
